import { render, staticRenderFns } from "./IconSvgUrl.vue?vue&type=template&id=601287ea&scoped=true&"
import script from "./IconSvgUrl.vue?vue&type=script&lang=js&"
export * from "./IconSvgUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601287ea",
  null
  
)

export default component.exports